import(/* webpackMode: "eager" */ "D:\\Kalpvruks\\Kalp-Ui-New\\src\\app\\(blank-layout-pages)\\main\\page.jsx");
